/* eslint-disable react/prop-types */
import PropTypes from 'prop-types';
import React from 'react';
import { Card } from 'react-bootstrap';

import { faSortDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './styles.css';

const SurveySections = ({ sectionData, surveyQuestions, onEditModeClick }) => {
  return (
    <Card className="survey-info-card" onClick={onEditModeClick}>
      <Card.Header className="survey-info-card-header">
        {sectionData.Data.name}
        <span>
          <FontAwesomeIcon size="lg" className="ml-1 mr-5" icon={faSortDown} />
        </span>
      </Card.Header>
      {surveyQuestions?.questions?.map((question) => (
        <div
          className="w-100 text-left border-0 bg-gray-200 py-2 d-flex mt-5"
          id={question?.id}
          key={question?.id}
        >
          <div className="w-100">
            <div className="cursor-pointer d-flex align-items-center mr-5">
              <h3 className="mt-3 mb-3 ml-5 mr-auto">
                <span className="mr-5">{question?.displayIdentifier}</span>
                <span>{question?.prompt}</span>
              </h3>
            </div>
          </div>
        </div>
      ))}
    </Card>
  );
};

SurveySections.propTypes = {
  sectionData: PropTypes.shape({}).isRequired,
  onEditModeClick: PropTypes.func.isRequired,
  surveyQuestions: PropTypes.arrayOf({}).isRequired,
};

SurveySections.defaultProps = {};

export default SurveySections;
